import { get, post } from "@/lib/api";
import type { ApprovalItem, ApprovalsResponse } from "@/types/approval";

export async function getApprovals(limit = 100): Promise<ApprovalsResponse | ApprovalItem[]> {
  const query = new URLSearchParams({ limit: String(limit) }).toString();
  return get<ApprovalsResponse | ApprovalItem[]>(`/approvals/?${query}`);
}

export function approveApproval(approvalId: string, body?: Record<string, unknown>) {
  return post(`/approvals/${encodeURIComponent(approvalId)}/approve`, body);
}

export function rejectApproval(approvalId: string, body?: Record<string, unknown>) {
  return post(`/approvals/${encodeURIComponent(approvalId)}/reject`, body);
}

export function escalateApproval(approvalId: string, body?: Record<string, unknown>) {
  return post(`/approvals/${encodeURIComponent(approvalId)}/escalate`, body);
}

export function runDeduplication(params?: { source?: "odoo" | "memory" | "crm"; limit?: number; reset?: boolean }) {
  const search = new URLSearchParams();
  if (params?.source) search.set("source", params.source);
  if (params?.limit) search.set("limit", String(params.limit));
  if (params?.reset) search.set("reset", "true");
  const suffix = search.toString();
  return post(`/dedup/run${suffix ? `?${suffix}` : ""}`);
}
